/**
 * Cafe Nativo Premium Motion & Narrative Interaction System
 * Apples-level motion design framework (GPU-accelerated, spring physics, scroll story, bean flight).
 */

document.addEventListener('DOMContentLoaded', () => {
  initPremiumButtonPresses();
  initCartAddMotionInterceptions();
  initScrollNarrativeReveals();
  initProductPageBrewRitual();
  initCartNotificationOverlayObserver();
  initGlobalStickyHeaderScroll();
  initMobileGlassDrawerMorph();
});

/**
 * Global Glass Floating Header Scroll Observer (Apple / Framer grade)
 */
function initGlobalStickyHeaderScroll() {
  const headerWrapper = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
  let ticking = false;

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const scrolled = window.scrollY > 10 || document.body.classList.contains('menu-open');
        document.body.classList.toggle('header-scrolled', scrolled);
        if (headerWrapper) {
          headerWrapper.classList.toggle('header-scrolled', scrolled);
        }
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/**
 * Header-to-Drawer Morphing Glass Animation Controller (Apple / Linear Grade)
 */
function initMobileGlassDrawerMorph() {
  const summary = document.querySelector('#Details-menu-drawer-container > summary');
  const details = document.querySelector('#Details-menu-drawer-container');
  const backdrop = document.querySelector('.menu-drawer-backdrop');
  const headerWrapper = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');

  if (!summary || !details) return;

  let isAnimating = false;
  let savedScrollY = 0;

  const openDrawer = () => {
    if (isAnimating) return;
    isAnimating = true;
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    details.setAttribute('open', 'true');
    details.classList.remove('menu-closing');
    details.classList.add('menu-opening');
    document.documentElement.classList.add('menu-open');
    document.body.classList.add('menu-open', 'header-scrolled');
    if (headerWrapper) {
      headerWrapper.classList.add('menu-open', 'header-scrolled');
    }
    setTimeout(() => {
      isAnimating = false;
    }, 350);
  };

  const closeDrawer = () => {
    if (isAnimating || !details.hasAttribute('open')) return;
    isAnimating = true;
    const currentScrollY = savedScrollY;

    details.classList.remove('menu-opening');
    details.classList.add('menu-closing');
    document.documentElement.classList.remove('menu-open');
    document.body.classList.remove('menu-open');
    if (headerWrapper) {
      headerWrapper.classList.remove('menu-open');
    }

    // Instantly preserve exact page scroll position
    window.scrollTo({ top: currentScrollY, behavior: 'instant' });

    if (currentScrollY <= 10) {
      document.body.classList.remove('header-scrolled');
      if (headerWrapper) {
        headerWrapper.classList.remove('header-scrolled');
      }
    } else {
      document.body.classList.add('header-scrolled');
      if (headerWrapper) {
        headerWrapper.classList.add('header-scrolled');
      }
    }

    setTimeout(() => {
      details.removeAttribute('open');
      details.classList.remove('menu-closing');
      window.scrollTo({ top: currentScrollY, behavior: 'instant' });
      isAnimating = false;
    }, 380);
  };

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    if (details.hasAttribute('open') && !details.classList.contains('menu-closing')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  const drawerCloseBtn = document.querySelector('.js-drawer-close');
  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  document.addEventListener('click', (e) => {
    if (details.hasAttribute('open') && !details.classList.contains('menu-closing')) {
      const drawer = document.querySelector('#menu-drawer');
      if (drawer && !drawer.contains(e.target) && !summary.contains(e.target)) {
        closeDrawer();
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && details.hasAttribute('open')) {
      closeDrawer();
    }
  });
}

/**
 * 1. Global Reusable Button Spring Press Interactions
 */
function initPremiumButtonPresses() {
  const buttonsSelector = '.button, .newsletter-form__button, .field__button, .quick-add__submit, .cart__checkout-button';
  
  document.addEventListener('mousedown', (e) => {
    const btn = e.target.closest(buttonsSelector);
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    
    btn.style.transform = 'scale(0.97) translateY(1px)';
    btn.style.transition = 'transform 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  });
  
  document.addEventListener('mouseup', (e) => {
    const btn = e.target.closest(buttonsSelector);
    if (!btn) return;
    
    // Spring release transition back to standard scale
    btn.style.transform = '';
    btn.style.transition = 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
  });
}

/**
 * 2. Advanced Add to Cart Animation Sequence (Interceptions, Flight, and Header Reactions)
 */
function initCartAddMotionInterceptions() {
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source !== 'product-form') return;
      
      const form = document.querySelector(`product-form[data-variant-id="${event.productVariantId}"] form`) || 
                   document.querySelector(`form[action*="/cart/add"]`);
      if (!form) return;
      
      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn) return;
      
      // Step 1: Trigger instant success state on the button
      const originalText = submitBtn.querySelector('span') ? submitBtn.querySelector('span').textContent : submitBtn.textContent;
      submitBtn.classList.add('button--added');
      if (submitBtn.querySelector('span')) {
        submitBtn.querySelector('span').textContent = '¡Añadido!';
      } else {
        submitBtn.textContent = '¡Añadido!';
      }
      
      // Spawn flight animation
      triggerCoffeeBeanFlight(submitBtn);
      
      setTimeout(() => {
        submitBtn.classList.remove('button--added');
        if (submitBtn.querySelector('span')) {
          submitBtn.querySelector('span').textContent = originalText;
        } else {
          submitBtn.textContent = originalText;
        }
      }, 2000);
    });
  }
}

/**
 * Coffee Bean Flight path calculation and render loop
 */
function triggerCoffeeBeanFlight(originBtn) {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (!cartIcon) return;
  
  const startRect = originBtn.getBoundingClientRect();
  const endRect = cartIcon.getBoundingClientRect();
  
  // Starting coordinates (center of the Add to Cart button)
  const startX = startRect.left + startRect.width / 2;
  const startY = startRect.top + startRect.height / 2;
  
  // Ending coordinates (center of the Cart icon bubble)
  const endX = endRect.left + endRect.width / 2;
  const endY = endRect.top + endRect.height / 2;
  
  // Create flight element
  const bean = document.createElement('div');
  bean.className = 'bean-flight-element';
  bean.style.cssText = `
    position: fixed;
    top: ${startY}px;
    left: ${startX}px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    margin-left: -12px;
    z-index: 9999999;
    pointer-events: none;
    will-change: transform, opacity;
    opacity: 0.9;
    filter: drop-shadow(0 2px 5px rgba(138, 98, 56, 0.4));
  `;
  
  // Simple elegant coffee bean outline SVG
  bean.innerHTML = `
    <svg viewBox="0 0 24 24" fill="#8A6238" width="100%" height="100%">
      <path d="M12 3c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L17.61 4.97A8.937 8.937 0 0012 3zm5.64 3.39L4.97 17.61A8.97 8.97 0 0012 21c4.97 0 9-4.03 9-9 0-2.12-.74-4.07-1.97-5.61z"/>
    </svg>
  `;
  
  document.body.appendChild(bean);
  
  // Quadratic Bezier curve control points
  const p0 = { x: startX, y: startY };
  const p2 = { x: endX, y: endY };
  // Curve high above the path
  const p1 = {
    x: (p0.x + p2.x) / 2,
    y: Math.min(p0.y, p2.y) - 180
  };
  
  const duration = 650; // ms
  const startTime = performance.now();
  
  function animateFlight(currentTime) {
    const elapsed = currentTime - startTime;
    const t = Math.min(elapsed / duration, 1);
    
    // Ease-inout quadratic bezier point formula
    const mt = 1 - t;
    const x = mt * mt * p0.x + 2 * mt * t * p1.x + t * t * p2.x;
    const y = mt * mt * p0.y + 2 * mt * t * p1.y + t * t * p2.y;
    
    // Rotate and scale down
    const rotation = t * 540;
    const scale = 1 - t * 0.55;
    const opacity = 1 - t * 0.15;
    
    bean.style.transform = `translate3d(${x - startX}px, ${y - startY}px, 0) rotate(${rotation}deg) scale(${scale})`;
    bean.style.opacity = opacity;
    
    if (t < 1) {
      requestAnimationFrame(animateFlight);
    } else {
      bean.remove();
      triggerHeaderCartReaction(cartIcon);
    }
  }
  
  requestAnimationFrame(animateFlight);
}

/**
 * Trigger header cart reaction bounce and ring animations
 */
function triggerHeaderCartReaction(cartIcon) {
  cartIcon.classList.remove('cart-icon--bounce');
  void cartIcon.offsetWidth; // trigger reflow
  cartIcon.classList.add('cart-icon--bounce');
  
  const countBadge = cartIcon.querySelector('.cart-count-bubble');
  if (countBadge) {
    countBadge.classList.remove('cart-badge--increment');
    void countBadge.offsetWidth;
    countBadge.classList.add('cart-badge--increment');
  }
  
  setTimeout(() => {
    cartIcon.classList.remove('cart-icon--bounce');
  }, 600);
}

/**
 * 3. Scroll Narrative and Intersection Observers (Homepage Coffee Journey)
 */
function initScrollNarrativeReveals() {
  const revealCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal-visible');
        observer.unobserve(entry.target); // trigger once
      }
    });
  };
  
  const observer = new IntersectionObserver(revealCallback, {
    root: null,
    threshold: 0.1,
    rootMargin: '0px 0px -60px 0px'
  });
  
  // Decorate homepage and primary scroll sections
  const sectionsToReveal = [
    '.hero__content-bounds',
    '.hero__image-side',
    '.our-history-section',
    '.featured-collection',
    '.footer-columns',
    '.footer-newsletter'
  ];
  
  sectionsToReveal.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      el.classList.add('reveal-on-scroll');
      observer.observe(el);
    });
  });

  // Setup parallax scroll events on split hero background image
  const parallaxBg = document.querySelector('.hero__split-img');
  if (parallaxBg) {
    window.addEventListener('scroll', () => {
      const scrollOffset = window.pageYOffset;
      const speed = 0.08;
      // Soft vertical drift
      requestAnimationFrame(() => {
        parallaxBg.style.transform = `translate3d(0, ${scrollOffset * speed}px, 0) scale(1.02)`;
      });
    }, { passive: true });
  }
}

/**
 * 4. Product Page "Brew Ritual" Parallax and Soft zoom reveals
 */
function initProductPageBrewRitual() {
  const productSection = document.querySelector('.product');
  if (!productSection) return;
  
  // Origin Product gallery reveal
  const gallery = productSection.querySelector('.product__media-wrapper');
  if (gallery) {
    gallery.classList.add('reveal-on-scroll');
    gallery.style.opacity = '0';
    gallery.style.transform = 'scale(0.97)';
    gallery.style.transition = 'opacity 1.2s ease, transform 1.2s cubic-bezier(0.16, 1, 0.3, 1)';
    
    // Soft scale-in reveal
    setTimeout(() => {
      gallery.style.opacity = '1';
      gallery.style.transform = 'scale(1)';
    }, 300);
  }
  
  // Description / Story reveals
  const productInfo = productSection.querySelector('.product__info-container');
  if (productInfo) {
    const infoItems = productInfo.children;
    for (let i = 0; i < infoItems.length; i++) {
      infoItems[i].classList.add('reveal-on-scroll');
      infoItems[i].style.transitionDelay = `${i * 0.08}s`;
    }
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    }, { threshold: 0.05 });
    
    Array.from(infoItems).forEach(item => observer.observe(item));
  }
}

/**
 * Fail-safe MutationObserver to toggle the body-level blur overlay
 * whenever `#cart-notification` opens/closes.
 */
function initCartNotificationOverlayObserver() {
  const target = document.getElementById('cart-notification');
  if (!target) return;

  // Create global overlay if it doesn't exist yet
  let overlay = document.querySelector('.cart-notification-global-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'cart-notification-global-overlay';
    document.body.appendChild(overlay);
    
    // Close cart notification on click
    overlay.addEventListener('click', () => {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) {
        cartNotification.close();
      } else {
        target.classList.remove('active');
        overlay.classList.remove('active');
      }
    });
  }

  // Create observer to listen for class changes on `#cart-notification`
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        const isActive = target.classList.contains('active');
        if (isActive) {
          overlay.classList.add('active');
        } else {
          overlay.classList.remove('active');
        }
      }
    });
  });

  observer.observe(target, { attributes: true });
}
